var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLangchain(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    width: 128,
    height: 128,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 128,
    rx: 28,
    fill: "#112240"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(16, 16)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 32,
    width: 60,
    height: 32,
    rx: 16,
    fill: "none",
    stroke: "#22c55e",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 16,
    width: 32,
    height: 64,
    rx: 16,
    fill: "none",
    stroke: "#38bdf8",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 48,
    r: 6,
    fill: "#64ffda"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 48,
    r: 6,
    fill: "#64ffda"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLangchain);
export default __webpack_public_path__ + "static/media/langchain.34f173e35d6ccf202b39e94a5cbb8d0f.svg";
export { ForwardRef as ReactComponent };